// extracted by mini-css-extract-plugin
export var productImage = "_qz-1";
export var viewLink = "_qz-2";
export var wishlistItem = "_qz-0";